/* Miniature-house play area (sections/play-minihouse.liquid). Lights switch + build slider; no libraries. */
(function () {
  var LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var DICT = {
    ru: { 'Lights off': 'Свет выключен', 'Light level': 'Яркость света' },
    de: { 'Lights off': 'Licht aus', 'Light level': 'Helligkeit' },
    es: { 'Lights off': 'Luces apagadas', 'Light level': 'Nivel de luz' },
    fr: { 'Lights off': 'Lumières éteintes', 'Light level': 'Niveau de lumière' },
    ar: { 'Lights off': 'الأضواء مطفأة', 'Light level': 'مستوى الإضاءة' }
  };
  function T(s, v) { var o = (DICT[LANG] || {})[s] || s; if (v) for (var k in v) o = o.split('{' + k + '}').join(v[k]); return o; }
  function init(root) {
    if (root.__mh) return; root.__mh = true;
    if (root.hasAttribute('data-asm')) return;      // the build-by-pieces version is run by mh-assemble.js
    var total = parseInt(root.getAttribute('data-parts'), 10) || 200;
    var range = root.querySelector('[data-mh-range]'), nEl = root.querySelector('[data-mh-n]');
    var lamp = root.querySelector('[data-mh-lamp]'), lampTxt = root.querySelector('[data-mh-lamptxt]');
    var play = root.querySelector('[data-mh-play]');
    var onTxt = lampTxt ? lampTxt.textContent : '';
    var raf = 0, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function set(n) {
      n = Math.max(0, Math.min(total, Math.round(n)));
      root.style.setProperty('--mh-p', (n / total).toFixed(4));
      if (nEl) nEl.textContent = n;
      if (range && +range.value !== n) range.value = n;
    }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function build(from, ms) {
      stop();
      if (reduce) return set(total);
      var t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - k, 2.2);
        set(from + (total - from) * e);
        if (k < 1) raf = requestAnimationFrame(step); else raf = 0;
      })(t0);
    }
    if (range) range.addEventListener('input', function () { stop(); set(+range.value); });
    if (play) play.addEventListener('click', function () { set(0); build(0, 4800); });
    // Light level 0 (night) .. 1 (lights on): drag the photo sideways, or use the switch.
    var stage = root.querySelector('.mh__stage'), L = 0.3, lraf = 0, offTxt = lamp ? (lamp.getAttribute('data-off') || T('Lights off')) : '';
    function setL(v) {
      L = Math.max(0, Math.min(1, v));
      root.style.setProperty('--mh-l', L.toFixed(3));
      var on = L > 0.5;
      root.setAttribute('data-lit', on ? '1' : '0');
      if (lamp) { lamp.setAttribute('aria-checked', on ? 'true' : 'false'); }
      if (lampTxt) lampTxt.textContent = on ? onTxt : offTxt;
    }
    function tweenL(to) {
      if (lraf) cancelAnimationFrame(lraf);
      if (reduce) return setL(to);
      var from = L, t0 = performance.now();
      (function step(t) { var k = Math.min(1, (t - t0) / 450); setL(from + (to - from) * (1 - Math.pow(1 - k, 3))); lraf = k < 1 ? requestAnimationFrame(step) : 0; })(t0);
    }
    function touched() { root.classList.add('is-touched'); }
    if (lamp) lamp.addEventListener('click', function () { touched(); tweenL(L > 0.5 ? 0 : 1); });
    if (stage) {
      var sx = 0, sl = 0, drag = false, moved = false;
      stage.addEventListener('pointerdown', function (e) { drag = true; moved = false; sx = e.clientX; sl = L; if (lraf) { cancelAnimationFrame(lraf); lraf = 0; } });
      stage.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
        if (moved) { touched(); setL(sl + dx / (stage.clientWidth * 0.7)); }
      });
      function end() { if (drag && !moved) { touched(); tweenL(L > 0.5 ? 0 : 1); } drag = false; }
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', function () { drag = false; });
      stage.addEventListener('pointerleave', function () { drag = false; });
      stage.setAttribute('tabindex', '0');
      stage.setAttribute('role', 'slider'); stage.setAttribute('aria-label', T('Light level')); stage.setAttribute('aria-valuemin', '0'); stage.setAttribute('aria-valuemax', '100');
      stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { touched(); setL(L + 0.1); } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { touched(); setL(L - 0.1); } });
    }
    setL(0.3);
    // first time in view: build from nothing once
    if ('IntersectionObserver' in window && !reduce) {
      var seen = false, io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !seen) { seen = true; io.disconnect(); set(0); build(0, 4200); } });
      }, { threshold: .45 });
      io.observe(root);
    }
  }
  function others(w) {
    if (w.__mhs) return; w.__mhs = true;
    var row = w.querySelector('[data-mh-row]'), prev = w.querySelector('[data-mh-prev]'), next = w.querySelector('[data-mh-next]'), thumb = w.querySelector('[data-mh-thumb]');
    if (!row) return;
    function upd() {
      var max = row.scrollWidth - row.clientWidth, x = row.scrollLeft;
      if (thumb) {
        var frac = row.clientWidth / Math.max(1, row.scrollWidth), tw = Math.max(12, frac * 100);
        thumb.style.width = tw + '%';
        thumb.style.transform = 'translateX(' + (max > 0 ? (x / max) * (100 / tw * (100 - tw)) : 0) + '%)';
      }
      if (prev) prev.disabled = x < 4;
      if (next) next.disabled = x > max - 4;
    }
    function step(dir) { row.scrollBy({ left: dir * Math.max(160, row.clientWidth * 0.8), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    // drag with the mouse (touch already scrolls natively)
    var down = false, sx = 0, sl = 0, moved = false;
    row.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = row.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; row.classList.add('is-drag'); } if (moved) row.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; row.classList.remove('is-drag'); });
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // the yellow bar: drag the thumb (mouse or finger), or click/tap the track to jump there
    var bar = w.querySelector('.mh-others__bar'), bd = null;
    if (bar && thumb) {
      bar.addEventListener('pointerdown', function (e) {
        var r = bar.getBoundingClientRect(), max = row.scrollWidth - row.clientWidth; if (max <= 0) return;
        var frac = row.clientWidth / Math.max(1, row.scrollWidth), free = r.width * (1 - frac);
        var tb = thumb.getBoundingClientRect();
        if (e.clientX < tb.left || e.clientX > tb.right) row.scrollLeft = Math.max(0, Math.min(max, ((e.clientX - r.left - r.width * frac / 2) / Math.max(1, free)) * max));
        bd = { x: e.clientX, sl: row.scrollLeft, free: free, max: max };
        try { bar.setPointerCapture(e.pointerId); } catch (er) {}
        row.style.scrollSnapType = 'none'; e.preventDefault();
      });
      bar.addEventListener('pointermove', function (e) { if (!bd) return; row.scrollLeft = Math.max(0, Math.min(bd.max, bd.sl + ((e.clientX - bd.x) / Math.max(1, bd.free)) * bd.max)); });
      var endBar = function () { if (!bd) return; bd = null; row.style.scrollSnapType = ''; };
      bar.addEventListener('pointerup', endBar); bar.addEventListener('pointercancel', endBar);
    }
    upd(); setTimeout(upd, 400);
  }
  function all() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mh-others]'), others); Array.prototype.forEach.call(document.querySelectorAll('[data-mh]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
